import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const handler = ( $ ) => {
	gsap.registerPlugin( ScrollTrigger );

	const $animated = $( '.is-animated' );

	const animation = {
		fadeInUp: ( el, { duration = 1, y = 50 } ) => {
			gsap.fromTo(
				el,
				{ opacity: 0, y },
				{
					opacity: 1,
					y: 0,
					duration,
					scrollTrigger: {
						trigger: el,
						toggleActions: 'restart none none none',
					},
				}
			);
		},

		fadeInDown: ( el, { duration = 1, y = -50 } ) => {
			gsap.fromTo(
				el,
				{ opacity: 0, y },
				{
					opacity: 1,
					y: 0,
					duration,
					scrollTrigger: {
						trigger: el,
						toggleActions: 'restart none none none',
					},
				}
			);
		},

		fadeInLeft: ( el, { duration = 1, x = 50 } ) => {
			gsap.fromTo(
				el,
				{ opacity: 0, x },
				{
					opacity: 1,
					x: 0,
					duration,
					scrollTrigger: {
						trigger: el,
						toggleActions: 'restart none none none',
					},
				}
			);
		},

		fadeInRight: ( el, { duration = 1, x = -50 } ) => {
			gsap.fromTo(
				el,
				{ opacity: 0, x },
				{
					opacity: 1,
					x: 0,
					duration,
					scrollTrigger: {
						trigger: el,
						toggleActions: 'restart none none none',
					},
				}
			);
		},

		fadeInRightIncrease: ( el, { duration = 1, x = -50, scale = 0.6 } ) => {
			gsap.fromTo(
				el,
				{ opacity: 0, x, scale },
				{
					opacity: 1,
					x: 0,
					scale: 1,
					transformOrigin: 'bottom left',
					duration,
					scrollTrigger: {
						trigger: el,
						toggleActions: 'restart none none none',
					},
				}
			);
		},

		fadeInRightTop: ( el, { duration = 1, x = -100, y = 50 } ) => {
			gsap.fromTo(
				el,
				{ opacity: 0, x, y },
				{
					opacity: 1,
					x: 0,
					y: 0,
					transformOrigin: 'bottom left',
					duration,
					scrollTrigger: {
						trigger: el,
						toggleActions: 'restart none none none',
					},
				}
			);
		},

		fadeInLeftTop: ( el, { duration = 1, x = 50, y = 50 } ) => {
			gsap.fromTo(
				el,
				{ opacity: 0, x, y },
				{
					opacity: 1,
					x: 0,
					y: 0,
					transformOrigin: 'bottom right',
					duration,
					scrollTrigger: {
						trigger: el,
						toggleActions: 'restart none none none',
					},
				}
			);
		},
	};

	$animated.each( function ( _, el ) {
		const $el = $( el );
		const name = $el.data( 'animation-name' ),
			duration = $el.data( 'animation-duration' ),
			y = $el.data( 'animation-y' ),
			x = $el.data( 'animation-x' );
		try {
			animation[ name ]( el, { duration, y, x } );
		} catch ( error ) {
			console.log( error );
		}
	} );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
